import React from "react";
import { VIcon } from "../keno/VCredit";

const ranks = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
const suits = ['♦', '♥', '♠', '♣'];
export const cardLabel = (value) => value === null ? 'Face-down card' : `${ranks[Math.floor(value / 4)]} ${suits[value % 4]}`;
export const visibleCardValue = (value) => {
  if (!Number.isInteger(value) || value < 0 || value > 51) return null;
  const rank = Math.floor(value / 4) + 2;
  return rank === 14 ? 11 : Math.min(rank, 10);
};

export const PlayingCard = ({ value = null, testid, instant = false, delay = 0, outcome = '' }) => {
  const back = value === null;
  const rank = back ? '' : ranks[Math.floor(value / 4)];
  const suit = back ? '' : suits[value % 4];
  return <div className={`bj-card ${back ? 'is-back' : value % 4 < 2 ? 'is-red' : 'is-black'} ${instant ? 'is-instant' : ''} ${outcome ? `outcome-${outcome}` : ''}`} style={{ '--card-delay': `${delay}ms` }} data-testid={testid} data-card={value ?? 'hidden'} data-outcome={outcome || 'pending'} role="img" aria-label={cardLabel(value)}>
    {back ? <div className="bj-card-back-frame"><VIcon className="bj-card-back-logo" /></div> : <>
      <span className="bj-card-corner"><b>{rank}</b><i>{suit}</i></span>
      <span className="bj-card-pip" aria-hidden="true">{suit}</span>
      <span className="bj-card-corner is-bottom" aria-hidden="true"><b>{rank}</b><i>{suit}</i></span>
    </>}
  </div>;
};